<template>
  <div>
    <Toolbar>
      <v-toolbar-title>
        <a href="/" title="Careship">
          <Logo />
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <CSButton
        href="tel:+4930220128831"
        flat
        icon
        iconName="cs_phone-call"
        id="nav_phone_btn"
        class="iconNavItem"
      />
      <CSButton
        @click="toggleOverlay(!displayOverlay)"
        flat
        icon
        :iconName="displayOverlay ? 'cross' : 'menu'"
        id="nav_toggle_btn"
        class="iconNavItem"
      />
    </Toolbar>
    <v-fade-transition mode="in-out">
      <div class="overlay" v-if="displayOverlay">
        <div class="navItems">
          <div
            :class="{ navItem__shadow: isAboutUsNavItemExpanded }"
            :aria-expanded="String(isAboutUsNavItemExpanded)"
          >
            <button
              class="navItem"
              @click="toogleIsAboutUsNavItemExpanded"
              @mousedown.prevent
            >
              <span class="navItem__title">{{
                translate('NAVBAR_ABOUT_US')
              }}</span>
              <CSSVGIcon
                class="navItem__icon"
                :iconName="
                  isAboutUsNavItemExpanded ? 'cs_chevron-up' : 'cs_chevron-down'
                "
              />
            </button>
            <v-expand-transition mode="in-out">
              <div v-if="isAboutUsNavItemExpanded">
                <a href="/ueber-uns" class="navItem__item">{{
                  translate('NAVBAR_ABOUT_CARESHIP')
                }}</a>
                <a href="/senioren-ratgeber" class="navItem__item">
                  {{ translate('NAVBAR_CARESHIP_MAGAZINE') }}</a
                >
                <a href="/faq" class="navItem__item">
                  {{ translate('NAVBAR_FAQ_CUSTOMERS') }}
                </a>
                <a href="/partner" class="navItem__item">
                  {{ translate('NAVBAR_PARTNERS') }}
                </a>
                <a href="/newsroom" class="navItem__item">
                  {{ translate('NAVBAR_PRESS') }}
                </a>
                <a
                  href="https://careship.jobs.personio.de/"
                  class="navItem__item"
                >
                  {{ translate('NAVBAR_CAREER') }}
                </a>
              </div>
            </v-expand-transition>
          </div>
          <div
            :class="{ navItem__shadow: isCaregiversNavItemExpanded }"
            :aria-expanded="String(isCaregiversNavItemExpanded)"
          >
            <button
              class="navItem"
              @click="toogleCaregiversNavItemExpanded"
              @mousedown.prevent
            >
              <span class="navItem__title">{{
                translate('NAVBAR_CAREGIVERS')
              }}</span>
              <CSSVGIcon
                class="navItem__icon"
                :iconName="
                  isCaregiversNavItemExpanded
                    ? 'cs_chevron-up'
                    : 'cs_chevron-down'
                "
              />
            </button>
            <v-expand-transition mode="in-out">
              <div v-if="isCaregiversNavItemExpanded">
                <a href="/unsere-betreuer" class="navItem__item">{{
                  translate('NAVBAR_OUR_CAREGIVERS')
                }}</a>
                <a href="/hilfe" class="navItem__item">{{
                  translate('NAVBAR_FAQ_CAREGIVERS')
                }}</a>
                <a href="https://my.careship.de/login" class="navItem__item">{{
                  translate('NAVBAR_MY_CARESHIP_LOGIN')
                }}</a>
              </div>
            </v-expand-transition>
          </div>
          <a href="/angebot" class="navItem">
            {{ translate('NAVBAR_SERVICES') }}
          </a>
          <a href="/preise" class="navItem">
            {{ translate('NAVBAR_PRICE') }}
          </a>
        </div>
        <div class="footer">
          <p v-if="isDashboardVariation" class="footer__hint">
            {{ translate('NAVBAR_DASHBOARD_DESCRIPTION') }}
          </p>
          <router-link
            v-if="isDashboardVariation"
            v-ripple
            to="/meine-alltagshelfer"
            class="footer__cta"
            @mousedown.native.prevent
            @click.native="toggleOverlay(false)"
          >
            {{ translate('NAVBAR_LOGGED_IN_AREA') }}
          </router-link>
          <router-link
            v-if="isDashboardVariation"
            to="/logout"
            class="footer__cta footer__cta--link"
            @mousedown.native.prevent
            @click.native="toggleOverlay(false)"
          >
            {{ translate('NAVBAR_LOGOUT') }}
          </router-link>
          <a
            v-if="isFunnelVariation"
            :href="SRDraftUrl"
            class="footer__cta"
            v-ripple
          >
            {{ translate('NAVBAR_CONTINUE_SEARCH') }}
          </a>
          <router-link
            v-if="isDefaultVariation"
            to="/login"
            class="footer__cta footer__cta--link"
            @click.native="toggleOverlay(false)"
            @mousedown.native.prevent
          >
            {{ translate('NAVBAR_LOGIN') }}
          </router-link>
          <a
            v-if="isDefaultVariation"
            href="/kunde/alltagshilfe/bewerbung"
            class="footer__cta footer__cta--link"
          >
            {{ translate('NAVBAR_BECOME_CAREGIVER') }}
          </a>
          <router-link
            v-if="isDefaultVariation"
            v-ripple
            to="/anfrage"
            class="footer__cta"
            @click.native="toggleOverlay(false)"
            @mousedown.native.prevent
          >
            {{ translate('NAVBAR_FIND_CAREGIVERS') }}
          </router-link>
        </div>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'
import CSButton from '@/components/atoms/button/CSButton.vue'
import Logo from './components/logo.vue'
import Toolbar from './components/toolbar.vue'

export default {
  name: 'navigation',
  components: {
    CSSVGIcon,
    CSButton,
    Logo,
    Toolbar,
  },
  data() {
    return {
      displayOverlay: false,
      isAboutUsNavItemExpanded: false,
      isCaregiversNavItemExpanded: false,
    }
  },
  computed: {
    isDefaultVariation() {
      return this.navVariation === 'default'
    },
    isDashboardVariation() {
      return this.navVariation === 'dashboard'
    },
    isFunnelVariation() {
      return this.navVariation === 'funnel'
    },
  },
  props: {
    navVariation: {
      required: true,
      type: String,
    },
    SRDraftUrl: {
      required: true,
      type: String,
    },
  },
  watch: {
    $route() {
      if (this.displayOverlay) {
        this.toggleOverlay(false)
      }
    },
  },
  methods: {
    toggleOverlay(isOpen) {
      this.displayOverlay = isOpen
    },
    toogleIsAboutUsNavItemExpanded() {
      this.isAboutUsNavItemExpanded = !this.isAboutUsNavItemExpanded
      this.isCaregiversNavItemExpanded = false
    },
    toogleCaregiversNavItemExpanded() {
      this.isCaregiversNavItemExpanded = !this.isCaregiversNavItemExpanded
      this.isAboutUsNavItemExpanded = false
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables/variables.styl'

$navItemTransition = 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.toolbar {
  box-shadow: 0 $cs-spaces.half $cs-space 0 rgba(0, 0, 0, 0.11);
}

.overlay {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  padding-top: $cs-header-height;
  background-color: $cs-white;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.navItems {
  flex: 0 1 auto;
  overflow: auto;
  flex-direction: column;
  display: flex;
  padding: $cs-space 0;
}

.iconNavItem {
  height: 44px;
  width: 44px;
}

.navItem {
  font-weight: 500;
  width: 100%;
  border-bottom: 1px solid $cs-slate-100;
  padding: $cs-space;
  display: flex;
  font-size: 16px;
  text-decoration: none;
  color: $cs-slate-400;
  letter-spacing: 0px;
  line-height: 24px;
  cursor: pointer;
  text-align: left;

  &--expanded {
    background-color: $cs-white;

    .navItem__icon {
      transform: rotate(180deg);
    }
  }

  &:focus {
    outline: none;
    background-color: $cs-slate-050;
  }
}

// added by vue router automatically
.navItem.router-link-active {
  border-left: 4px solid $cs-primary;
  padding-left: ($cs-space) - 4px;
}

.navItem__shadow {
  box-shadow: 0 0 $cs-space 0 rgba(0, 0, 0, 0.05);
}

.navItem__item {
  text-decoration: none;
  color: $cs-slate-400;
  width: 100%;
  padding: 12px 0 12px $cs-spaces.double;
  display: flex;
  font-size: 16px;
  background-color: $cs-white;
  letter-spacing: 0;
  line-height: 24px;

  &:first-child {
    padding-top: $cs-space;
  }

  &:last-child {
    padding-bottom: $cs-space;
    border-bottom: 1px solid $cs-slate-100;
  }

  &:focus {
    outline: none;
    background-color: $cs-slate-050;
  }
}

// added by vue router automatically
.navItem__item.router-link-active {
  background-color: #fff7e5;
  font-weight: 500;
}

.navItem__title {
  flex: 1;
}

.navItem__icon {
  height: $cs-spaces.onehalf;
  width: $cs-spaces.onehalf;
}

.footer {
  background-color: $cs-white;
  padding: $cs-spaces.onehalf $cs-space;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
}

.footer__cta {
  font-size: 16px;
  font-weight: 500;
  padding: $cs-spaces.half $cs-spaces.onehalf;
  background-color: $cs-primary;
  color: $cs-white;
  border-radius: 28px;
  text-decoration: none;
  transition: opacity $navItemTransition;
  height: 40px;
  text-align: center;
  margin-bottom: $cs-space;
  letter-spacing: 0px;
  line-height: 24px;

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    outline: none;
    opacity: 0.8;
  }

  &--link {
    background-color: $cs-white;
    color: $cs-slate-400;
  }
}

.footer__hint {
  align-self: center;
  font-size: 14px;
  font-weight: 500;
  color: $cs-slate-300;
  margin: 0;
  margin-bottom: $cs-space;
}
</style>
